import { useEffect, useMemo } from "react";
import { useUiStore, UiState } from "@/store/ui.state";

interface UseGoBackOptions {
  /**
   * If true, the `goBack` value will be passed to the dependencies of the effect.
   * This is useful if you want to update the `goBack` value dynamically.
   * If false, the effect will only run on mount and unmount.
   */
  allowChanges?: boolean;
}

export const useGoBack = (
  goBack: UiState["header"]["goBack"],
  { allowChanges: passBackToDeps = false }: UseGoBackOptions = {},
) => {
  const { goBack: currentGoBack, setGoBack } = useUiStore((state) => state.header);
  const prevGoBack = useMemo(() => currentGoBack, []);

  useEffect(() => {
    setGoBack(goBack);

    return () => {
      setGoBack(prevGoBack);
    };
  }, [passBackToDeps && goBack, setGoBack]);
};
